// // // import React, { useEffect, useState } from 'react';
// // // import Breadcrumb from '@components/Shared/Breadcrumb';
// // // import { Card, CardBody } from '@components/card/card';
// // // import { useTranslation } from 'react-i18next';
// // // import Loading from '@components/Shared/Loader/Loading';
// // // import { useAppDispatch, useAppSelector } from '@store/hooks';
// // // import { getNoneInventoryList } from '@store/purchases/PurchaseBill/purchaseBillSlice';
// // // import NeatixModal from '@components/Modal/NeatixModal';
// // // import Receive from './Receive';
// // // import NtxTable from '@components/DataTable/NtxTable';
// // // import { Can } from '@Permisstions/Can';

// // // const Index = () => {
// // //   const [show, setShow] = useState(false);
// // //   const [item, setItem] = useState<any>();

// // //   const { t, i18n } = useTranslation();
// // //   const dispatch = useAppDispatch();

// // //   useEffect(() => {
// // //     dispatch(getNoneInventoryList());
// // //   }, [dispatch]);

// // //   const { NoneInventoryList, loading, error } = useAppSelector(a => a.PurchaseBill);

// // //   const columns = [
// // //     { title: t('PurchaseRequestNumber'), key: 'code' },
// // //     { title: t('PurchaseRequestDate'), key: 'date' },
// // //     { title: t('Branch'), key: 'branch' },
// // //     { title: t(''), key: 'action', className: 'text-end' }
// // //   ];

// // //   const tableData = NoneInventoryList?.map(item => {
// // //     let rowClass;

// // //     return {
// // //       code: item.code,
// // //       date: item.transactionDate?.toString()?.split('T')[0],
// // //       branch: i18n.language === 'en' ? item.organizationName : item.organizationName2,

// // //       action: (
// // //         <>
// // //           <Can permission={'PURViewPurchaseOrderNoneInventoryDetails'}>
// // //             <button
// // //               type='button'
// // //               className='btn btn-outline-theme mx-1'
// // //               onClick={() => {
// // //                 setItem(item);
// // //                 setShow(true);
// // //               }}
// // //             >
// // //               <i className='far fa-lg fa-fw me-2 fa-eye'></i> {t('عرض التفاصيل')}
// // //             </button>
// // //           </Can>
// // //         </>
// // //       )
// // //     };
// // //   });

// // //   const titleModal = () => {
// // //     return (
// // //       <div className=''>
// // //         {t('ReceiveNoneInventoryItems')}
// // //         {'  '}
// // //         <span className='text-theme'>{item?.code}</span>
// // //       </div>
// // //     );
// // //   };

// // //   //____________________________

// // //   return (
// // //     <div>
// // //       <div className='d-flex align-items-center'>
// // //         <Breadcrumb
// // //           BreadcrumbList={[
// // //             {
// // //               name: 'Home',
// // //               link: ':moduleHome'
// // //             },
// // //             {
// // //               name: 'ReceiveNoneInventoryItems',
// // //               link: null
// // //             }
// // //           ]}
// // //           PageName='معالجة العمليات الغيـر مخزنيـة'
// // //         />
// // //       </div>
// // //       <Card>
// // //         <Loading loading={loading} error={error}>
// // //           <CardBody>
// // //             <div className='p-2'>
// // //               <NtxTable
// // //                 data={tableData || []}
// // //                 columns={columns}
// // //                 dataPerPage={10}
// // //                 theadClass=''
// // //                 tableClass='table text-nowrap table-hover '
// // //                 enableSearch
// // //                 showRecordsSelector
// // //               />
// // //             </div>
// // //           </CardBody>
// // //         </Loading>
// // //       </Card>

// // //       <NeatixModal show={show} setShow={setShow} showHeader={false} bodyClassName='p-3' size='xl' title={titleModal() as any}>
// // //         <CardBody>{item && <Receive id={item.id} onclose={() => setShow(false)} />}</CardBody>
// // //       </NeatixModal>
// // //     </div>
// // //   );
// // // };

// // // export default Index;

// // import React, { useEffect, useState } from 'react';
// // import Breadcrumb from '@components/Shared/Breadcrumb';
// // import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';
// // import { useTranslation } from 'react-i18next';
// // import Loading from '@components/Shared/Loader/Loading';
// // import { useAppDispatch, useAppSelector } from '@store/hooks';
// // import { getNoneInventoryList } from '@store/purchases/PurchaseBill/purchaseBillSlice';
// // import NeatixModal from '@components/Modal/NeatixModal';
// // import Receive from './Receive';
// // import { Can } from '@Permisstions/Can';
// // import { useNavigate } from 'react-router-dom';

// // const Index = () => {
// //   const [show, setShow] = useState(false);
// //   const [item, setItem] = useState<any>();
// //   const [showFilters, setShowFilters] = useState(false);

// //   // ✅ فلاتر أعلى الصفحة
// //   const [branchFilter, setBranchFilter] = useState<any>(null);
// //   const [dateFrom, setDateFrom] = useState('');
// //   const [dateTo, setDateTo] = useState('');
// //   const [searchFilter, setSearchFilter] = useState('');

// //   const [activeFiltersCount, setActiveFiltersCount] = useState(0);

// //   const { t, i18n } = useTranslation();
// //   const dispatch = useAppDispatch();
// //   const navigate = useNavigate();

// //   useEffect(() => {
// //     dispatch(getNoneInventoryList());
// //   }, [dispatch]);

// //   const { NoneInventoryList, loading, error } = useAppSelector(a => a.PurchaseBill);

// //   // محاكاة البيانات للفلاتر (يمكن استبدالها ببيانات حقيقية)
// //   const branchOptions = [
// //     { value: '1', label: t('الفرع الرئيسي') },
// //     { value: '2', label: t('فرع الرياض') },
// //     { value: '3', label: t('فرع جدة') },
// //   ];

// //   const applyFilters = () => {
// //     // تطبيق الفلاتر هنا
// //     console.log('Applying filters:', { branchFilter, dateFrom, dateTo, searchFilter });
// //     setActiveFiltersCount(
// //       (branchFilter ? 1 : 0) +
// //       (dateFrom ? 1 : 0) +
// //       (dateTo ? 1 : 0) +
// //       (searchFilter ? 1 : 0)
// //     );
// //   };

// //   const clearFilters = () => {
// //     setBranchFilter(null);
// //     setDateFrom('');
// //     setDateTo('');
// //     setSearchFilter('');
// //     setActiveFiltersCount(0);
// //   };

// //   const titleModal = () => {
// //     return (
// //       <div className=''>
// //         {t('ReceiveNoneInventoryItems')}
// //         {'  '}
// //         <span className='text-theme'>{item?.code}</span>
// //       </div>
// //     );
// //   };

// //   const formatDate = (dateString: string) => {
// //     return dateString?.split('T')[0] || '';
// //   };

// //   return (
// //     <div>
// //       {/* ✅ شريط التنقل */}
// //       <div className='d-flex flex-wrap align-items-center gap-2 mb-3'>
// //         <Breadcrumb
// //           BreadcrumbList={[
// //             { name: t('Home'), link: ':moduleHome' },
// //             { name: t('معالجة العمليات الغيـر مخزنيـة'), link: null }
// //           ]}
// //           PageName={t('معالجة العمليات الغيـر مخزنيـة')}
// //         />
// //       </div>

// //       {/* ✅ شريط الفلاتر */}
// //       <Card className='mb-3 shadow bg-body1'>
// //         <CardHeader>
// //           <div className='row g-2'>
// //             {/* الفرع */}
// //             <div className='col-lg-4'>
// //               <div className='input-group'>
// //                 <span className='input-group-text fw-bold'>
// //                   <i className='fas fa-building'></i>
// //                 </span>
// //                 <select
// //                   className='form-select'
// //                   value={branchFilter?.value || ''}
// //                   onChange={(e) => setBranchFilter(
// //                     e.target.value ? { value: e.target.value, label: branchOptions.find(b => b.value === e.target.value)?.label } : null
// //                   )}
// //                 >
// //                   <option value="">{t('اختر الفرع')}</option>
// //                   {branchOptions.map(option => (
// //                     <option key={option.value} value={option.value}>
// //                       {option.label}
// //                     </option>
// //                   ))}
// //                 </select>
// //               </div>
// //             </div>

// //             {/* التاريخ من وإلى */}
// //             <div className='col-lg-4'>
// //               <div className='input-group'>
// //                 <span className='input-group-text'>
// //                   <i className='fas fa-calendar-alt text-muted'></i>
// //                 </span>
// //                 <input
// //                   type='date'
// //                   className='form-control border-start-0'
// //                   value={dateFrom}
// //                   onChange={e => setDateFrom(e.target.value)}
// //                   placeholder={t('From')}
// //                 />
// //                 <span className='input-group-text'>-</span>
// //                 <input
// //                   type='date'
// //                   className='form-control'
// //                   value={dateTo}
// //                   onChange={e => setDateTo(e.target.value)}
// //                   placeholder={t('To')}
// //                 />
// //               </div>
// //             </div>

// //             {/* أزرار */}
// //             <div className='col-lg-4 text-end'>
// //               <button
// //                 className='btn btn-outline-secondary me-2'
// //                 type='button'
// //                 onClick={clearFilters}
// //                 title={t('ClearFilters')}
// //                 disabled={activeFiltersCount === 0}
// //               >
// //                 <i className='fas fa-times fa-fw'></i>
// //               </button>

// //               <button
// //                 className='btn btn-theme me-2'
// //                 type='button'
// //                 onClick={applyFilters}
// //                 title={t('ApplyFilters')}
// //                 disabled={!branchFilter && !dateFrom && !dateTo && !searchFilter}
// //               >
// //                 <i className='fas fa-filter fa-fw'></i>
// //               </button>

// //               <button
// //                 className='btn btn-outline-theme'
// //                 onClick={() => setShowFilters(true)}
// //                 title={t('AdvancedFilters')}
// //               >
// //                 <i className='fas fa-sliders-h fa-fw'></i>
// //               </button>
// //             </div>

// //             {/* بحث */}
// //             <div className='col-12 mt-2'>
// //               <div className='input-group'>
// //                 <span className='input-group-text fw-bold'>
// //                   <i className='fas fa-search'></i>
// //                 </span>
// //                 <input
// //                   className='form-control'
// //                   value={searchFilter}
// //                   onChange={e => setSearchFilter(e.target.value)}
// //                   placeholder={t('بحث برقم العملية')}
// //                 />
// //               </div>
// //             </div>
// //           </div>
// //         </CardHeader>
// //       </Card>

// //       {/* ✅ الجدول */}
// //       <Card className='mb-4'>
// //         <Loading loading={loading} error={error}>
// //           <CardBody className='p-0'>
// //             <div className='table-responsive'>
// //               <table className='table table-hover mb-0'>
// //                 <thead className='bg-theme bg-opacity-25 fw-bold'>
// //                   <tr>
// //                     <th className='small'>{t('PurchaseRequestNumber')}</th>
// //                     <th className='small'>{t('PurchaseRequestDate')}</th>
// //                     <th className='small'>{t('Branch')}</th>
// //                     <th className='small text-center'>{t('Actions')}</th>
// //                   </tr>
// //                 </thead>

// //                 <tbody>
// //                   {NoneInventoryList && NoneInventoryList.length > 0 ? (
// //                     NoneInventoryList.map((item: any) => (
// //                       <tr key={item.id}>
// //                         <td className='align-middle'>
// //                           <strong className='text-theme'>{item.code}</strong>
// //                         </td>

// //                         <td className='align-middle'>
// //                           {formatDate(item.transactionDate)}
// //                         </td>

// //                         <td className='align-middle'>
// //                           {i18n.language === 'en' ? item.organizationName : item.organizationName2}
// //                         </td>

// //                         <td className='align-middle text-end'>
// //                           <div className='d-flex justify-content-end gap-2'>
// //                             <Can permission={'PURViewPurchaseOrderNoneInventoryDetails'}>
// //                               <button
// //                                 type='button'
// //                                 className='btn btn-sm btn-outline-theme'
// //                                 onClick={() => {
// //                                   setItem(item);
// //                                   setShow(true);
// //                                 }}
// //                                 title={t('عرض التفاصيل')}
// //                               >
// //                                 <i className='far fa-lg fa-fw me-2 fa-eye'></i>
// //                                 {t('عرض التفاصيل')}
// //                               </button>
// //                             </Can>
// //                           </div>
// //                         </td>
// //                       </tr>
// //                     ))
// //                   ) : (
// //                     <tr>
// //                       <td colSpan={4} className='text-center py-4 text-muted'>
// //                         <i className='fa fa-inbox fa-2x mb-2'></i>
// //                         <br />
// //                         {activeFiltersCount > 0 ? t('NoSearchResults') : t('لا توجد عمليات غير مخزنية')}
// //                       </td>
// //                     </tr>
// //                   )}
// //                 </tbody>
// //               </table>
// //             </div>
// //           </CardBody>
// //         </Loading>

// //         <CardFooter>
// //           <div className='text-theme d-flex justify-content-between align-items-center'>
// //             <div className='text-muted small'>
// //               {t('Showing')} {NoneInventoryList?.length || 0} {t('items')}
// //             </div>
// //             {/* يمكن إضافة pagination هنا إذا كان موجودًا */}
// //           </div>
// //         </CardFooter>
// //       </Card>

// //       <NeatixModal
// //         show={show}
// //         setShow={setShow}
// //         showHeader={true}
// //         bodyClassName='p-3'
// //         size='xl'
// //         title={titleModal() as any}
// //       >
// //         <CardBody>
// //           {item && <Receive id={item.id} onclose={() => setShow(false)} />}
// //         </CardBody>
// //       </NeatixModal>
// //     </div>
// //   );
// // };

// // export default Index;

// import { useEffect, useState, useMemo } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';
// import { useTranslation } from 'react-i18next';
// import Loading from '@components/Shared/Loader/Loading';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { getNoneInventoryList } from '@store/purchases/PurchaseBill/purchaseBillSlice';
// import NeatixModal from '@components/Modal/NeatixModal';
// import Receive from './Receive';
// import { Can } from '@Permisstions/Can';
// import { Link } from 'react-router-dom';

// const Index = () => {
//   const [show, setShow] = useState(false);
//   const [item, setItem] = useState<any>();

//   // ✅ فلاتر أعلى الصفحة
//   const [branchFilter, setBranchFilter] = useState<any>(null);
//   const [supplierFilter, setSupplierFilter] = useState<any>(null);
//   const [dateFrom, setDateFrom] = useState('');
//   const [dateTo, setDateTo] = useState('');
//   const [searchFilter, setSearchFilter] = useState('');
//   const [statusFilter, setStatusFilter] = useState<any>(null);

//   const [activeFiltersCount, setActiveFiltersCount] = useState(0);

//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();

//   useEffect(() => {
//     dispatch(getNoneInventoryList());
//   }, [dispatch]);

//   const { NoneInventoryList, loading, error } = useAppSelector(a => a.PurchaseBill);

//   // استخراج الخيارات من البيانات
//   const branchOptions = useMemo(() => {
//     const branches = new Map();
//     NoneInventoryList?.forEach(item => {
//       if (item.organizationId && item.organizationName) {
//         branches.set(item.organizationId, {
//           value: item.organizationId,
//           label: i18n.language === 'en' ? item.organizationName : item.organizationName2 || item.organizationName
//         });
//       }
//     });
//     return Array.from(branches.values());
//   }, [NoneInventoryList, i18n.language]);

//   const supplierOptions = useMemo(() => {
//     const suppliers = new Map();
//     NoneInventoryList?.forEach(item => {
//       if (item.peopleId && item.peopleName) {
//         suppliers.set(item.peopleId, {
//           value: item.peopleId,
//           label: i18n.language === 'en' ? item.peopleName : item.peopleName2 || item.peopleName
//         });
//       }
//     });
//     return Array.from(suppliers.values());
//   }, [NoneInventoryList, i18n.language]);

//   const statusOptions = [
//     { value: 'received', label: t('تم الاستلام') },
//     { value: 'pending', label: t('قيد الانتظار') },
//     { value: 'partially', label: t('مستلم جزئياً') }
//   ];

//   const applyFilters = () => {
//     let count = 0;
//     if (branchFilter) count++;
//     if (supplierFilter) count++;
//     if (dateFrom) count++;
//     if (dateTo) count++;
//     if (searchFilter) count++;
//     if (statusFilter) count++;

//     setActiveFiltersCount(count);

//     // هنا يمكن إضافة منطق تصفية البيانات الفعلي
//     console.log('Applying filters:', {
//       branchFilter,
//       supplierFilter,
//       dateFrom,
//       dateTo,
//       searchFilter,
//       statusFilter
//     });
//   };

//   const clearFilters = () => {
//     setBranchFilter(null);
//     setSupplierFilter(null);
//     setDateFrom('');
//     setDateTo('');
//     setSearchFilter('');
//     setStatusFilter(null);
//     setActiveFiltersCount(0);
//   };

//   const getStatusBadge = (item: any) => {
//     if (item.noneInventoryFlag === true) {
//       return (
//         <span className='badge border border-success text-success px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
//           <i className='fa fa-check-circle fs-15px fa-fw me-5px'></i>
//           {t('تم الاستلام')}
//         </span>
//       );
//     } else if (item.noneInventoryFlag === false) {
//       return (
//         <span className='badge border border-warning text-warning px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
//           <i className='fa fa-clock fs-15px fa-fw me-5px'></i>
//           {t('قيد الانتظار')}
//         </span>
//       );
//     }

//     return (
//       <span className='badge border border-secondary text-secondary px-2 pt-5px pb-5px rounded fs-12px'>
//         {t('غير محدد')}
//       </span>
//     );
//   };

//   const formatAmount = (amount: number) =>
//     new Intl.NumberFormat(i18n.language, {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(amount || 0);

//   const formatDate = (dateString: string) => {
//     return dateString?.split('T')[0] || '';
//   };

//   // تصفية البيانات بناءً على الفلاتر
//   const filteredData = useMemo(() => {
//     if (!NoneInventoryList) return [];

//     let filtered = [...NoneInventoryList];

//     // تصفية حسب الفرع
//     if (branchFilter?.value) {
//       filtered = filtered.filter(item => item.organizationId === branchFilter.value);
//     }

//     // تصفية حسب المورد
//     if (supplierFilter?.value) {
//       filtered = filtered.filter(item => item.peopleId === supplierFilter.value);
//     }

//     // تصفية حسب البحث
//     if (searchFilter) {
//       const searchLower = searchFilter.toLowerCase();
//       filtered = filtered.filter(
//         item =>
//           item.code?.toLowerCase().includes(searchLower) ||
//           (i18n.language === 'en'
//             ? item.peopleName?.toLowerCase().includes(searchLower)
//             : item.peopleName2?.toLowerCase().includes(searchLower))
//       );
//     }

//     return filtered;
//   }, [NoneInventoryList, branchFilter, supplierFilter, dateFrom, dateTo, statusFilter, searchFilter, i18n.language]);

//   const titleModal = () => {
//     return (
//       <div className='d-flex align-items-center'>
//         <span className='me-2'>{t('ReceiveNoneInventoryItems')}</span>
//         <span className='text-theme fw-bold'>{item?.code}</span>
//       </div>
//     );
//   };

//   return (
//     <div>
//       {/* ✅ شريط التنقل */}
//       <div className='d-flex flex-wrap align-items-center gap-2  '>
//         <Breadcrumb
//           BreadcrumbList={[
//             { name: t('Home'), link: ':moduleHome' },
//             { name: t('معالجة العمليات الغيـر مخزنيـة'), link: null }
//           ]}
//           PageName={t('معالجة العمليات الغيـر مخزنيـة')}
//         />
//       </div>

//       {/* ✅ شريط الفلاتر */}
//       <Card className='mb-3 shadow bg-body1'>
//         <CardHeader>
//           <div className='row g-2'>
//             {/* الفرع */}
//             <div className='col-lg-3'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-building'></i>
//                 </span>
//                 <select
//                   className='form-select'
//                   value={branchFilter?.value || ''}
//                   onChange={e => {
//                     const value = e.target.value;
//                     setBranchFilter(value ? branchOptions.find(b => b.value === value) || null : null);
//                   }}
//                   disabled={branchOptions.length === 0}
//                 >
//                   <option value=''>{t('اختر الفرع')}</option>
//                   {branchOptions.map(option => (
//                     <option key={option.value} value={option.value}>
//                       {option.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             {/* المورد */}
//             <div className='col-lg-3'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-truck'></i>
//                 </span>
//                 <select
//                   className='form-select'
//                   value={supplierFilter?.value || ''}
//                   onChange={e => {
//                     const value = e.target.value;
//                     setSupplierFilter(value ? supplierOptions.find(s => s.value === value) || null : null);
//                   }}
//                   disabled={supplierOptions.length === 0}
//                 >
//                   <option value=''>{t('اختر مورد')}</option>
//                   {supplierOptions.map(option => (
//                     <option key={option.value} value={option.value}>
//                       {option.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//           </div>
//         </CardHeader>
//       </Card>

//       {/* ✅ الجدول */}
//       <Card className='mb-4'>
//         <Loading loading={loading} error={error}>
//           <CardBody className='p-0'>
//             <div className='table-responsive'>
//               <table className='table table-hover mb-0'>
//                 <thead className='bg-theme bg-opacity-25 fw-bold'>
//                   <tr>
//                     <th className='small'>{t('Number')}</th>
//                     <th className='small'>{t('Date')}</th>
//                     <th className='small'>{t('Supplier')}</th>
//                     <th className='small'>{t('وحدة التشيـل')}</th>
//                     <th className='small'>{t('المبلغ')}</th>
//                     <th className='small'>{t('حالة الاستلام')}</th>
//                     <th className='small text-center'>{t('Actions')}</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {filteredData && filteredData.length > 0 ? (
//                     filteredData.map((item: any) => (
//                       <tr key={item.id}>
//                         <td className='align-middle'>
//                           <strong className='text-theme'>{item.code}</strong>
//                           {item.supplierInvoiceNum && (
//                             <div className='small text-muted'>
//                               {t('فاتورة المورد:')} {item.supplierInvoiceNum}
//                             </div>
//                           )}
//                         </td>

//                         <td className='align-middle'>
//                           <div>{formatDate(item.transactionDate)}</div>
//                         </td>

//                         <td className='align-middle'>
//                           <div className='fw-semibold'>
//                             {i18n.language === 'en' ? item.peopleName : item.peopleName2}
//                           </div>
//                           {item.description && (
//                             <div className='small text-muted text-truncate' style={{ maxWidth: '150px' }}>
//                               {item.description}
//                             </div>
//                           )}
//                         </td>

//                         <td className='align-middle'>
//                           {i18n.language === 'en' ? item.organizationName : item.organizationName2}
//                         </td>

//                         <td className='align-middle'>
//                           <div className='fw-bold text-theme'>{formatAmount(item.netAmount)}</div>
//                         </td>

//                         <td className='align-middle'>{getStatusBadge(item)}</td>

//                         <td className='align-middle text-end'>
//                           <div className='d-flex justify-content-end gap-2'>
//                             <Can permission={'PURViewPurchaseOrderNoneInventoryDetails'}>
//                               <button
//                                 type='button'
//                                 className='btn btn-sm btn-outline-theme d-flex align-items-center'
//                                 onClick={() => {
//                                   setItem(item);
//                                   setShow(true);
//                                 }}
//                                 title={t('عرض التفاصيل')}
//                               >
//                                 <i className='far fa-eye fa-fw me-2'></i>
//                                 {t('عرض')}
//                               </button>
//                             </Can>

//                             {item.noneInventoryFlag === false && (
//                               <Can permission={'PURReceiveNoneInventoryItems'}>
//                                 <Link
//                                   to={`/purchases/none-inventory/receive/${item.id}`}
//                                   className='btn btn-sm btn-theme d-flex align-items-center'
//                                   title={t('استلام')}
//                                 >
//                                   <i className='fas fa-check-circle fa-fw me-2'></i>
//                                   {t('استلام')}
//                                 </Link>
//                               </Can>
//                             )}
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan={7} className='text-center py-4 text-muted'>
//                         <i className='fa fa-inbox fa-2x mb-2'></i>
//                         <br />
//                         {activeFiltersCount > 0 ? t('NoSearchResults') : t('لا توجد عمليات غير مخزنية')}
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </CardBody>
//         </Loading>

//         <CardFooter>
//           <div className='text-theme d-flex justify-content-between align-items-center'>
//             <div className='text-muted small'>
//               {t('Showing')} {filteredData?.length || 0} {t('of')} {NoneInventoryList?.length || 0} {t('items')}
//             </div>
//             {activeFiltersCount > 0 && (
//               <div className='small'>
//                 <span className='badge bg-theme text-white'>
//                   {activeFiltersCount} {t('فلاتر نشطة')}
//                 </span>
//               </div>
//             )}
//           </div>
//         </CardFooter>
//       </Card>

//       <NeatixModal
//         show={show}
//         setShow={setShow}
//         showHeader={false}
//         // bodyClassName='p-0'
//         size='xl'

//         // title={titleModal() as any}
//         // onClose={() => setItem(undefined)}
//       >
//         {item && (
//           <Receive
//             id={item.id}
//             onclose={() => {
//               setShow(false);
//               setItem(undefined);
//               // إعادة تحميل البيانات بعد الإغلاق إذا لزم الأمر
//               dispatch(getNoneInventoryList());
//             }}
//           />
//         )}
//       </NeatixModal>
//     </div>
//   );
// };

// export default Index;


import { useEffect, useState, useMemo } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import Loading from '@components/Shared/Loader/Loading';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getNoneInventoryList } from '@store/purchases/PurchaseBill/purchaseBillSlice';
import NeatixModal from '@components/Modal/NeatixModal';
import Receive from './Receive';
import { Can } from '@Permisstions/Can';
import { Link, useNavigate } from 'react-router-dom';
import Select from 'react-select';

const Index = () => {
  const [show, setShow] = useState(false);
  const [item, setItem] = useState<any>();
  const [showFilters, setShowFilters] = useState(false);

  // ✅ فلاتر أعلى الصفحة
  const [supplierFilter, setSupplierFilter] = useState<any>(null);
  const [organizationFilter, setOrganizationFilter] = useState<any>(null);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [searchFilter, setSearchFilter] = useState('');

  const [activeFiltersCount, setActiveFiltersCount] = useState(0);

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getNoneInventoryList());
  }, [dispatch]);

  const { NoneInventoryList, loading, error } = useAppSelector(a => a.PurchaseBill);

  // استخراج الخيارات من البيانات
  const OperatingUnitOptions = useMemo(() => {
    const branches = new Map();
    NoneInventoryList?.forEach(item => {
      if (item.organizationId && item.organizationName) {
        branches.set(item.organizationId, {
          value: item.organizationId,
          label: i18n.language === 'en' ? item.organizationName : item.organizationName2 || item.organizationName
        });
      }
    });
    return Array.from(branches.values());
  }, [NoneInventoryList, i18n.language]);

  const OptionSuppliers = useMemo(() => {
    const suppliers = new Map();
    NoneInventoryList?.forEach(item => {
      if (item.peopleId && item.peopleName) {
        suppliers.set(item.peopleId, {
          value: item.peopleId,
          label: i18n.language === 'en' ? item.peopleName : item.peopleName2 || item.peopleName
        });
      }
    });
    return Array.from(suppliers.values());
  }, [NoneInventoryList, i18n.language]);

  const applyFilters = () => {
    let count = 0;
    if (supplierFilter) count++;
    if (organizationFilter) count++;
    if (dateFrom) count++;
    if (dateTo) count++;
    if (searchFilter) count++;

    setActiveFiltersCount(count);

    // هنا يمكن إضافة منطق تصفية البيانات الفعلي
    console.log('Applying filters:', {
      supplierFilter,
      organizationFilter,
      dateFrom,
      dateTo,
      searchFilter
    });
  };

  const clearFilters = () => {
    setSupplierFilter(null);
    setOrganizationFilter(null);
    setDateFrom('');
    setDateTo('');
    setSearchFilter('');
    setActiveFiltersCount(0);
  };

  const getStatusBadge = (item: any) => {
    if (item.noneInventoryFlag === true) {
      return (
        <span className='badge border border-success text-success px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
          <i className='fa fa-check-circle fs-15px fa-fw me-5px'></i>
          {t('تم الاستلام')}
        </span>
      );
    } else if (item.noneInventoryFlag === false) {
      return (
        <span className='badge border border-warning text-warning px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
          <i className='fa fa-clock fs-15px fa-fw me-5px'></i>
          {t('قيد الانتظار')}
        </span>
      );
    }

    return (
      <span className='badge border border-secondary text-secondary px-2 pt-5px pb-5px rounded fs-12px'>
        {t('غير محدد')}
      </span>
    );
  };

  const formatAmount = (amount: number) =>
    new Intl.NumberFormat(i18n.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount || 0);

  // ✅ النوع: إذا متعدد -> "متعدد" ، غير ذلك -> اسم المخزن + "مخزن واحد"
  const getTypeOrInventoryDisplay = (item: any) => {
    if (item?.isMultiInventoryFlag) {
      return (
        <span className='badge border border-success text-success px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
          <i className='fa fa-layer-group fs-15px fa-fw me-5px'></i>
          {t('متعدد')}
        </span>
      );
    }

    const invName = i18n.language === 'en' ? item?.inventoryName : item?.inventoryName2;

    return (
      <div className='d-flex flex-column'>
        <span className='fw-bold1 text-theme1'>{invName || '-'}</span>
      </div>
    );
  };

  const breadcrumbList = [
    { name: t('Home'), link: ':moduleHome' },
    { name: t('معالجة العمليات الغيـر مخزنيـة'), link: null }
  ];

  // تصفية البيانات بناءً على الفلاتر
  const filteredData = useMemo(() => {
    if (!NoneInventoryList) return [];

    let filtered = [...NoneInventoryList];

    // تصفية حسب وحدة التشغيل
    if (organizationFilter?.value) {
      filtered = filtered.filter(item => item.organizationId === organizationFilter.value);
    }

    // تصفية حسب المورد
    if (supplierFilter?.value) {
      filtered = filtered.filter(item => item.peopleId === supplierFilter.value);
    }

    // تصفية حسب التاريخ من
    if (dateFrom) {
      const fromMs = new Date(dateFrom).getTime();
      filtered = filtered.filter(item =>
        item.transactionDate && new Date(item.transactionDate).getTime() >= fromMs
      );
    }

    // تصفية حسب التاريخ إلى
    if (dateTo) {
      const toMs = new Date(`${dateTo}T23:59:59`).getTime();
      filtered = filtered.filter(item =>
        item.transactionDate && new Date(item.transactionDate).getTime() <= toMs
      );
    }

    // تصفية حسب البحث
    if (searchFilter) {
      const searchLower = searchFilter.toLowerCase();
      filtered = filtered.filter(item => 
        item.code?.toLowerCase().includes(searchLower) ||
        (i18n.language === 'en' 
          ? item.peopleName?.toLowerCase().includes(searchLower)
          : item.peopleName2?.toLowerCase().includes(searchLower)
        )
      );
    }

    return filtered;
  }, [NoneInventoryList, organizationFilter, supplierFilter, dateFrom, dateTo, searchFilter, i18n.language]);

  return (
    <>
      <div className='d-flex flex-wrap align-items-center gap-2'>
        <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('معالجة العمليات الغيـر مخزنيـة')} />
      </div>

      {/* ✅ شريط الفلاتر */}
      <Card className='mb-3 shadow bg-body1'>
        <CardHeader>
          <div className='row g-2'>
            {/* وحدة التشغيل */}
            <div className='col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-building'></i>
                </span>
                <Select
                  value={organizationFilter}
                  onChange={setOrganizationFilter}
                  options={OperatingUnitOptions}
                  placeholder={t('اختر وحدة التشغيـل')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* المورد */}
            <div className='col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-truck'></i>
                </span>
                <Select
                  value={supplierFilter}
                  onChange={setSupplierFilter}
                  options={OptionSuppliers}
                  placeholder={t('اختر مورد')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* التاريخ من وإلى */}
            <div className='col-lg-4'>
              <div className='input-group'>
                <span className='input-group-text'>
                  <i className='fas fa-calendar-alt text-muted'></i>
                </span>
                <input
                  type='date'
                  className='form-control border-start-0'
                  value={dateFrom}
                  onChange={e => setDateFrom(e.target.value)}
                  placeholder={t('From')}
                />
                <span className='input-group-text'>-</span>
                <input
                  type='date'
                  className='form-control'
                  value={dateTo}
                  onChange={e => setDateTo(e.target.value)}
                  placeholder={t('To')}
                />
              </div>
            </div>

            {/* أزرار */}
            {/* <div className='col-lg-2 text-end'>
              <button
                className='btn btn-outline-secondary me-2'
                type='button'
                onClick={clearFilters}
                title={t('ClearFilters')}
                disabled={activeFiltersCount === 0}
              >
                <i className='fas fa-times fa-fw'></i>
              </button>

              <button
                className='btn btn-theme me-2'
                type='button'
                onClick={applyFilters}
                title={t('ApplyFilters')}
                disabled={!supplierFilter && !organizationFilter && !dateFrom && !dateTo && !searchFilter}
              >
                <i className='fas fa-filter fa-fw'></i>
              </button>

              <button
                className='btn btn-outline-theme w-md-auto'
                onClick={() => setShowFilters(true)}
                title={t('AdvancedFilters')}
              >
                <i className='fas fa-sliders-h fa-fw'></i>
              </button>
            </div> */}

            {/* بحث */}
            <div className='col-12'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-search'></i>
                </span>
                <input
                  className='form-control'
                  value={searchFilter}
                  onChange={e => setSearchFilter(e.target.value)}
                  placeholder={t('بحث برقم العملية أو اسم المورد')}
                  onKeyPress={(e) => e.key === 'Enter' && applyFilters()}
                />
              </div>
            </div>
          </div>
        </CardHeader>
      </Card>

      {/* ✅ الجدول */}
      <Card className='mb-4'>
        <Loading loading={loading} error={error}>
          <CardBody className='p-0'>
            <div className='table-responsive'>
              <table className='table table-hover mb-0'>
                <thead className='bg-theme bg-opacity-25 fw-bold'>
                  <tr>
                    <th className='small'>{t('Number')}</th>
                    <th className='small'>{t('Date')}</th>
                    <th className='small'>{t('Supplier')}</th>
                    <th className='small'>{t('Branch')}</th>
                    <th className='small'>{t('المخزن')}</th>
                    <th className='small'>{t('Amount')}</th>
                    <th className='small'>{t('Status')}</th>
                    <th className='small text-center'>{t('Actions')}</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredData && filteredData.length > 0 ? (
                    filteredData.map((item: any) => {
                      return (
                        <tr key={item.id}>
                          <td className='align-middle'>
                            <strong className='text-theme'>{item.code}</strong>
                            {item.supplierInvoiceNum && (
                              <div className='small text-muted'>
                                {/* {t('فاتورة المورد:')} {item.supplierInvoiceNum} */}
                              </div>
                            )}
                          </td>

                          <td className='align-middle'>
                            {String(item.transactionDate || '').split('T')[0]}
                          
                          </td>

                          <td className='align-middle'>
                            {i18n.language === 'en' ? item.peopleName : item.peopleName2}
                             
                          </td>

                          <td className='align-middle'>
                            {i18n.language === 'en' ? item.organizationName : item.organizationName2}
                          </td>

                          <td className='align-middle'>
                            {getTypeOrInventoryDisplay(item)}
                          </td>

                          <td className='align-middle'>
                            <span className='fw-bold text-theme'>{formatAmount(item.netAmount)}  </span>
                            
                          </td>

                          <td className='align-middle'>
                            {getStatusBadge(item)}
                          </td>

                          <td className='align-middle text-end'>
                            <div className='d-flex justify-content-end gap-2'>
                              <Can permission={'PURViewPurchaseOrderNoneInventoryDetails'}>
                                <button
                                  type='button'
                                  className='btn btn-sm btn-outline-theme d-flex align-items-center'
                                  onClick={() => {
                                    setItem(item);
                                    setShow(true);
                                  }}
                                  title={t('عرض التفاصيل')}
                                >
                                  <i className='far fa-eye fa-fw me-2'></i>
                                  {t('عرض')}
                                </button>
                              </Can>

                              {item.noneInventoryFlag === false && (
                                <Can permission={'PURReceiveNoneInventoryItems'}>
                                  <Link
                                    to={`/purchases/none-inventory/receive/${item.id}`}
                                    className='btn btn-sm btn-theme d-flex align-items-center'
                                    title={t('استلام')}
                                  >
                                    <i className='fas fa-check-circle fa-fw me-2'></i>
                                    {t('استلام')}
                                  </Link>
                                </Can>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={8} className='text-center py-4 text-muted'>
                        <i className='fa fa-inbox fa-2x mb-2'></i>
                        <br />
                        {activeFiltersCount > 0 ? t('NoSearchResults') : t('لا توجد عمليات غير مخزنية')}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Loading>

        <CardFooter>
          <div className='text-theme d-flex justify-content-between align-items-center'>
            {/* <div className='text-muted small'>
              {t('Showing')} {filteredData?.length || 0} {t('of')} {NoneInventoryList?.length || 0} {t('items')}
            </div> */}
            {activeFiltersCount > 0 && (
              <div className='small'>
                <span className='badge bg-theme text-white'>
                  {activeFiltersCount} {t('فلاتر نشطة')}
                </span>
              </div>
            )}
          </div>
        </CardFooter>
      </Card>

      <NeatixModal
        show={show}
        setShow={setShow}
        showHeader={false}
        // bodyClassName='p-0'
        size='xl'
      >
        {item && (
          <Receive
            id={item.id}
            onclose={() => {
              setShow(false);
              setItem(undefined);
              // إعادة تحميل البيانات بعد الإغلاق إذا لزم الأمر
              dispatch(getNoneInventoryList());
            }}
          />
        )}
      </NeatixModal>
    </>
  );
};

export default Index;